import styled from 'styled-components';

type StarRatingProps = {
  label: string;
  value?: number;
  onChange: (value: number) => void;
};

const STAR_EMPTY = '/images/yellowpage/star.svg';
const STAR_FILLED = '/images/yellowpage/star_fill.svg';

const StarRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 20px;
`;

const StarButton = styled.button`
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  &:focus-visible {
    outline: 2px solid ${(p) => p.theme.colors.primary500};
    outline-offset: 4px;
  }
`;

const StarRating = ({ label, value = 0, onChange }: StarRatingProps) => (
  <StarRow role="group" aria-label={label}>
    {[1, 2, 3, 4, 5].map((score) => {
      const selected = score <= value;

      return (
        <StarButton
          key={score}
          type="button"
          aria-label={`${label} ${score}`}
          aria-pressed={selected}
          onClick={() => onChange(score)}
        >
          <img src={selected ? STAR_FILLED : STAR_EMPTY} alt="" />
        </StarButton>
      );
    })}
  </StarRow>
);

export default StarRating;
